import Swiper from 'swiper';

// Carousels
class Carousel {
  constructor() {
    const productGalleries = [].slice.call(
      document.querySelectorAll('.product__carousel__items')
    );

    if (productGalleries.length > 0) {
      productGalleries.forEach(productGallery => {
        this.productCarousel(productGallery);
      });
    }
  }

  productCarousel(item) {
    this.swiper = new Swiper(item, {
      centeredSlides: true,
      effect: 'fade',
      loop: true,
      shortSwipes: false,
      slidesPerView: 1,
      slidesPerGroup: 1,
      navigation: {
        prevEl: '.product__carousel__arrow--previous',
        nextEl: '.product__carousel__arrow--next',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
      }
    });
  }
}

const carouselInit = {
  init() {
    // if element exists init this class
    const carouselElem = [].slice.call(document.querySelectorAll('.carousel'));
    if (carouselElem.length > 0) {
      carouselElem.forEach(el => {
        // eslint-disable-next-line no-unused-vars
        const carouselWrap = new Carousel(el);
      });
    }
  },
};

export default carouselInit;
